exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nh3[data-v-a333ee78] {\n    color: #4c4c4c;\n    margin: 5rem 0;\n    line-height: 1.4em;\n}\np[data-v-a333ee78] {\n    margin-top: 1rem;\n    font-size: 15px;\n    color: #999999;\n    text-align: center;\n}\n.content[data-v-a333ee78] {\n    width: 100%;\n}\n", ""]);

